import React from 'react';

import { Overlay } from '../styles';

/**
 * Renders the modal backdrop.
 *
 * @param backdropProps - Backdrop props.
 *
 * @returns Backdrop component.
 */
export function Backdrop(backdropProps: Props) {
  const { show, children, onPress } = backdropProps;

  if (!show) {
    return null;
  }

  return (
    <Overlay
      onClick={onPress}
      as="div"
      className="backdrop">
      {children}
    </Overlay>
  );
}
/* Type definitions */
type Props = React.PropsWithChildren<{
  /** Controls the backdrop visibility */
  show: boolean;
  /** Emits an `OnPress` event when the backdrop is press */
  onPress(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void;
}>;
